export default defineNuxtRouteMiddleware(async (to, from) => {
  const {
    sessionExpired,
    refreshAuthUser,
    fetchClientPrincipal,
    hasClientPrincipal,
    loginRedirect,
  } = useAuthentication()
  const localePath = useLocalePath()
  const normalizePath = localePath(to.path, 'en')
  const isPublicRoute = normalizePath.startsWith('/public') || to.meta?.environment === 'public'

  if (to.name === from.name || isPublicRoute) {
    if (sessionExpired.value) {
      // Public routes are open to anonymous visitors. Only load the user when SWA reports a
      // login session, so anonymous visitors don't get a 401 from /api/users/current (and its
      // console errors). Local dev has no SWA auth, as in the principal check below.
      if (isPublicRoute && !import.meta.dev && !(await hasClientPrincipal())) return
      await refreshAuthUser(false)
    }
    return
  }

  const result = await fetchClientPrincipal()

  if (result.clientPrincipal == null && !import.meta.dev) {
    loginRedirect(to.fullPath)
    return
  }

  if (sessionExpired.value) {
    await refreshAuthUser()
  }

  return
})
